import { TourState, TourStatus } from '../types';

/**
 * Status is derived from timestamps, never stored.
 * Absent record -> notStarted. See CONTEXT.md.
 */
export const deriveStatus = (state?: TourState): TourStatus => {
  if (!state) return 'notStarted';
  // Terminal timestamps outrank the empty-history check, and the order matters. The history is
  // client-only, so a tour completed on another device — or marked completed server-side by the
  // onboarding migration — arrives with a completedAt and NO local history. Testing history
  // first would call that 'notStarted' and cheerfully start the tour over.
  if (state.completedAt) return 'completed';
  if (state.skippedAt) return 'skipped';
  if (state.stepHistory.length === 0) return 'notStarted';
  return 'active';
};

/**
 * A cleared tour no longer competes for the screen. Paused does NOT clear.
 *
 * Takes a status rather than a state, for the callers that already hold one (`TourMobileGate`
 * reads `selectTourStatus`). `isCleared` below is the same question asked of a record.
 */
export const isClearedStatus = (status: TourStatus): boolean => status === 'skipped' || status === 'completed';

/** A cleared tour no longer competes for the screen. Paused does NOT clear. */
export const isCleared = (state?: TourState): boolean => isClearedStatus(deriveStatus(state));

/** A tour that is running and still competing for the screen. */
export const isRunning = (state?: TourState): boolean => deriveStatus(state) === 'active';
